import { useEffect } from "react";
import { useToken } from "src/business-hooks/useToken";

const LogoutUtilityPage = () => {
  const { logout } = useToken();

  useEffect(() => {
    void logout();
  }, [logout]);

  return null;
};

export default LogoutUtilityPage;
